<template>
	<div v-if="isPageVisible">
		<div class="page" :class="[ editor.mode ]" :id="'section-' + name">
			<page-editor-comment v-if="name == 'editor_comment'" />
			<!-- KYANEOS -->
			<div class="template-kyaneos">
				<page-kyaneos-1 v-if="name === 'scpi-presentation'" :index="index" />
				<page-kyaneos-2 v-if="name === 'scpi-situation'" :index="index" />
				<page-kyaneos-3 v-if="name === 'scpi-elements-descriptifs'" :index="index" />
				<page-kyaneos-4 v-if="name === 'scpi-situation-locative'" :index="index" />
				<page-kyaneos-5 v-if="name === 'scpi-marche-revente'" :index="index" />
				<page-kyaneos-6 v-if="name === 'scpi-evaluation'" :index="index" />
				<page-kyaneos-7 v-if="name === 'scpi-evaluation-2'" :index="index" />
				<page-kyaneos-lexique-table v-if="name.includes('scpi-lexique-table')" :name="name" :index="index"/>
			</div>
			
			<!-- LLI & LAC -->
			<page-garde v-if="name == 'garde'" :index="index" />
			<page-grand-projet v-if="name == 'grand_projet'" :index="index" />
			<page-territoire v-if="name == 'territoire'" :index="index" /><!-- needs to match json template slug name of the section -->
			<page-marches v-if="name == 'marches'" :index="index" />
			<page-situation v-if="name == 'situation' && active_study.etudeType.slug !== 'actu'" :index="index" />
			<page-situation-actualisation v-if="name == 'situation' && active_study.etudeType.slug === 'actu'" :index="index" />
			<page-lexique1 v-if="name == 'lexique1'" :index="index" />
			<page-lexique2 v-if="name == 'lexique2'" :index="index" />
			<page-map v-if="name == 'lli-map'" :index="index" />

				<!-- GIE -->
			<page-gie-1 v-if="name === '1-gie-classique'" :index="index" />
			<page-gie-2 v-if="name === '2-gie-classique'" :index="index"/>
			<page-gie-2-flash v-if="name === '2-gie-flash'" :index="index"/>
			<page-gie-3 v-if="name === '3-gie-classique'" :index="index"/>
			<page-gie-3-flash v-if="name === '3-gie-flash'" :index="index"/>
			<page-gie-4 v-if="name === '4-gie-classique'" :index="index"/>
			<page-gie-5 v-if="name === '5-gie-classique'" :index="index"/>
			<page-gie-lexique v-if="name === 'gie-lexique'" :index="index"/>
			<page-gie-lexique2 v-if="name === 'gie-map'" :index="index"/>

			<div class="footer" v-if="name != 'editor_comment'">
				<span class="copyright"><img src="@/assets/img/copyright.png"></span>
				<span class="dot sep">•</span>
				<!-- <span class="text">{{ active_study.template.etudeType.nom }} <span class="dot">•</span> {{ active_study.projet.geoDetails.ville.label }} <span class="dot">•</span> Patrimoine <span class="dot">•</span> {{ footer_date(active_study.dateCreation) }}</span> -->
				<!-- <span class="text">
					Etude Flash - {{active_study.projet.adresse.adresse}} - {{ active_study.projet.adresse.ville }} ({{active_study.projet.geoDetails.departement.label}}) - CDC H - {{footer_date(active_study.projet.dateCommande)}}
				</span> -->
				<span class="text" v-if="active_study.segment.code == 'LLI' || active_study.segment.code == 'LAC' ">
					Etude Flash - {{active_study.projet.adresse.ville }} ({{active_study.projet.adresse.codeInsee }}) - CDC H - {{footer_date(active_study.projet.dateCommande)}}
				</span>
				<span class="text" v-if="active_study.segment.code == 'GIE'">
					Etude <span v-if="this.active_study.etudeType.nom==='Flash'" >Flash </span>Valorisation patrimoine - {{active_study.projet.adresse.ville }} ({{active_study.projet.adresse.codeInsee }}) - CDC H - {{footer_date(active_study.projet.dateCommande)}}
				</span>
				
				<div class="no-page" >
					{{ calculatedIndex }}
				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

import moment from "moment";

import PageEditorComment from "@/components/study/editor/pages/page-editor-comment";

import PageGarde from "@/components/study/editor/pages/page-garde";
import PageTerritoire from "@/components/study/editor/pages/page-territoire";
import PageMarches from "@/components/study/editor/pages/page-marches";
import PageSituation from "@/components/study/editor/pages/page-situation";
import PageSituationActualisation from "@/components/study/editor/pages/page-situation-actualisation";
import PageLexique1 from "@/components/study/editor/pages/page-lexique1";
import PageLexique2 from "@/components/study/editor/pages/page-lexique2";
import PageGrandProjet from "./pages/page-grand-projet.vue";
import PageMap from "./pages/page-map.vue";

import PageGie1 from "@/components/study/editor/pages/page-gie-1.vue";
import PageGie2 from "@/components/study/editor/pages/page-gie-2";
import PageGie2Flash from "@/components/study/editor/pages/page-gie-2-flash";
import PageGie3 from "@/components/study/editor/pages/page-gie-3";
import PageGie3Flash from "@/components/study/editor/pages/page-gie-3-flash";
import PageGie4 from "@/components/study/editor/pages/page-gie-4";
import PageGie5 from "@/components/study/editor/pages/page-gie-5";
import PageGieLexique from "@/components/study/editor/pages/page-gie-lexique";
import PageGieLexique2 from "@/components/study/editor/pages/page-gie-lexique2";

import PageKyaneos1 from "@/components/study/editor/pages/page-kyaneos-1.vue";
import PageKyaneos2 from "@/components/study/editor/pages/page-kyaneos-2.vue";
import PageKyaneos3 from "@/components/study/editor/pages/page-kyaneos-3.vue";
import PageKyaneos4 from "@/components/study/editor/pages/page-kyaneos-4.vue";
import PageKyaneos5 from "@/components/study/editor/pages/page-kyaneos-5.vue";
import PageKyaneos6 from "@/components/study/editor/pages/page-kyaneos-6.vue";
import PageKyaneos7 from "@/components/study/editor/pages/page-kyaneos-7.vue";
import PageKyaneosLexiqueTable from "@/components/study/editor/pages/page-kyaneos-lexique-table";


moment.locale("fr");

export default {
	name: "page",
	props: [ "name", "index" ],
	computed: {
		...mapGetters([ "editor", "active_study" ]),
		isPageVisible () {
			// Show GIE page 5 only if one of its table is enabled
			if(this.name === "5-gie-classique") {
				return ((this.active_study.etudeData.gie.sectionComplements.show_locaux_commerciaux_table || this.active_study.etudeData.gie.sectionComplements.show_bail_emphyteotique_table) || this.editor.mode === "editing");
			}

			return true;
		},
		calculatedIndex (){
			const addition = (this.active_study.segment.code === "GIE" || this.active_study.segment.code === "SCPI" ? 0 : 1);
			return ((this.index || 0) + addition) + " / " + (this.active_study.template.sections.length + addition);
		}
	},
	methods: {
		footer_date: function (study_date) {
			return moment(study_date).format("MMMM YYYY");
		}
	},
	components: {
		PageEditorComment,
		PageGarde,
		PageTerritoire,
		PageMarches,
		PageSituation,
		PageSituationActualisation,
		PageLexique1,
		PageLexique2,
		PageGrandProjet,
		PageMap,
		PageGie1,
		PageGie2,
		PageGie2Flash,
		PageGie3,
		PageGie3Flash,
		PageGie4,
		PageGie5,
		PageGieLexique,
		PageGieLexique2,
		PageKyaneos1,
		PageKyaneos2,
		PageKyaneos3,
		PageKyaneos4,
		PageKyaneos5,
		PageKyaneos6,
		PageKyaneos7,
		PageKyaneosLexiqueTable
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/app'
@import '../../../assets/css/grid'

.page
	// width 827px
	width 792px
	// height 1170px
	// height 1168px
	height 1120px
	background #fff
	box-shadow 0 0 16px #000
	// border solid 0.5px red
	transform-origin top center
	transition 0.15s easeOutQuart

	&#section-editor_comment
		height 300px
		background lighten(purple, 85%);

	&:after
		content ''
		display none
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		cursor default
		z-index 10000
	&.editing
		&:after
			display block
			background-color #fff
			opacity 0.50
		>>> .can-change
			z-index 10001
	.page-content
		padding 8px 16px 68px 16px
	.loader
		position absolute
		left 0
		top 0
		right 0
		bottom 0
		display flex
		align-items center
		justify-content center
		background #fff
		z-index 1000000
		> .icon
			animation rotate 1s linear infinite
	.footer
		position absolute
		left 64px
		bottom 14px
		right 48px
		line-height 16px
		white-space nowrap
		font-size 8px
		color #3e5d58
		font-family 'VolteRounded-Medium', sans-serif
		.copyright
			float left
			height @line-height
			img
				width auto
				top 9%
				height 64%
		.dot
			transform translateY(-2px)
			margin 0 2px
		.sep
			display inline-block
			padding 0 4px 0 6px
			transform translateY(-1px)
		.no-page
			position absolute
			right 0
			bottom 0
			color #999


</style>